export const SET_WATCHED_LIST_ACTION = 'SET_WATCHED_LIST_ACTION';
export const SET_WATCHED_LIST_SUCCESS_ACTION =
  'SET_WATCHED_LIST_SUCCESS_ACTION';
export const SET_WATCHED_LIST_FAILURE_ACTION =
  'SET_WATCHED_LIST_FAILURE_ACTION';
